import ThreeUsersIcon from '@/icons/menu/3UsersIcon';
import HeartIcon from '@/icons/menu/HeartIcon';
import MoreCircle from '@/icons/menu/MoreCircle';
import { ENABLE_ANTI_FRAUD_INITIATIVE } from '@/modules/jobs/constants';
import type { MenuSection } from '../types';

export const generalMenu = () =>
  ({
    type: 'section',
    id: 'general',
    label: 'General',
    children: [
      {
        type: 'link',
        id: 'general-manage-team',
        label: 'Manage Team',
        icon: ({ isActive }) =>
          isActive ? (
            <ThreeUsersIcon.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <ThreeUsersIcon className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
        href: '/manage-team',
      },
      {
        type: 'collapse',
        id: 'general-settings',
        label: 'Settings',
        icon: ({ isOpen }) =>
          isOpen ? (
            <MoreCircle.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <MoreCircle className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
        href: ({ unleashFlag }) => {
          if (unleashFlag['job-portal-admin.dcp_7855.splitted_settings']) {
            return '/settings/personal-info';
          }

          return '/settings';
        },
        onlyWhen: ({ unleashFlag }) => {
          return unleashFlag['job-portal-admin.dcp_7855.splitted_settings'];
        },
        children: [
          {
            type: 'link',
            id: 'general-settings-personal-info',
            label: 'Personal Info',
            href: '/settings/personal-info',
          },
          {
            type: 'link',
            id: 'general-settings-subscription',
            label: 'Subscription',
            href: '/settings/subscription',
            onlyWhen: ({ userCompanyData }) => {
              return (
                userCompanyData?.company?.verificationStatus !== 'pending' &&
                ENABLE_ANTI_FRAUD_INITIATIVE
              );
            },
          },
          {
            type: 'link',
            id: 'general-settings-boost-job',
            label: 'Boost Job',
            href: '/settings/job-boost',
          },
          {
            type: 'link',
            id: 'general-settings-billing',
            label: 'Billing & Invoicing',
            href: '/settings/billing',
          },
          {
            type: 'link',
            id: 'general-settings-password',
            label: 'Password',
            href: '/settings/password',
          },
        ],
      },
      {
        type: 'link',
        id: 'general-settings',
        label: 'Settings',
        icon: ({ isActive }) =>
          isActive ? (
            <MoreCircle.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <MoreCircle className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
        href: '/settings',
        onlyWhen: ({ unleashFlag }) => {
          return !unleashFlag['job-portal-admin.dcp_7855.splitted_settings'];
        },
      },
      {
        type: 'link',
        id: 'general-send-feedback',
        label: 'Send Feedback',
        icon: ({ isActive }) =>
          isActive ? (
            <HeartIcon.Primary className="shrink-0 text-xs text-violet-500 !size-3" />
          ) : (
            <HeartIcon className="shrink-0 text-xs text-neutral-500 !size-3" />
          ),
        href: '/help-center',
      },
    ],
  }) as const satisfies MenuSection;
